<script>
import { mapState, mapGetters } from "vuex";

import orderMixin from "@/mixins/orderMixin";
import currencyMixin from "@/mixins/generic/currencyMixin";

export default {
  mixins: [orderMixin, currencyMixin],

  computed: {
    ...mapState("payable", ["payable", "accountBalance", "accountBonus"]),

    ...mapGetters("payable", [
      "canPayWithAccountBonus",
      "canPayWithAccountBalance"
    ]),

    ...mapState("user", ["user"])
  }
};
</script>

<template>
  <div class="total">
    <span>Total</span>

    <div>
      <div class="amount" :class="{'subtotal': (!canPayWithAccountBalance || canPayWithAccountBonus) && (accountBalance || accountBonus || payable.paid_by_account_balance)}">{{ payable | getOrderTotal }}</div>
      <div class="amount" v-if="!canPayWithAccountBalance && accountBalance">{{ payable.amount.total - user.payment_gateway_account.wallet.available_to_use | toCurrency }}</div>
      <div class="amount" v-else-if="canPayWithAccountBonus && accountBonus">{{ payable.amount.total - user.payment_gateway_account.wallet.bonus | toCurrency }}</div>
      <div class="amount" v-else-if="!canPayWithAccountBalance && payable.paid_by_account_balance">{{ payable.amount.total - payable.paid_by_account_balance | toCurrency }}</div>
    </div>
  </div>
</template>

<style scoped>
.total {
  display: flex;
  align-items: start;
  justify-content: space-between;
}

span {
  font-size: 20px;
  font-weight: 500;
}

.amount {
  width: 100%;
  font-weight: 500;
  text-align: end;
  color: #424242;
}

.subtotal {
  font-size: 14px;
  text-decoration: line-through;
  font-weight: 400;
  margin-bottom: 6px;
  color: #727272;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payable/OrderComponents/Total.vue